import { Component } from '@theme/component';

/**
 * Wires the purchase-option (one-time / subscription) and delivery-interval
 * selects into the product's add-to-cart form, via the native `selling_plan`
 * form field Shopify's cart/checkout expects. Fully decoupled from the
 * buy-buttons form markup - finds it by id and manages a hidden input there.
 */
class ProductSellingPlanSelector extends Component {
  requiredRefs = ['oneTimeRadio'];

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#handleChange);
    this.#syncHiddenInput();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#handleChange);
  }

  get #form() {
    const formId = this.dataset.formId;
    return formId ? document.getElementById(formId) : null;
  }

  #handleChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;

    if (target instanceof HTMLInputElement && target.type === 'radio') {
      const { intervalSelects } = this.refs;
      const groups = Array.isArray(intervalSelects) ? intervalSelects : intervalSelects ? [intervalSelects] : [];
      for (const select of groups) {
        const wrapper = select.closest('.cr-selling-plan-selector__interval');
        if (!wrapper) continue;
        wrapper.hidden = select.dataset.groupId !== target.value;
      }
    }

    this.#syncHiddenInput();
  };

  #syncHiddenInput() {
    const form = this.#form;
    if (!form) return;

    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    let sellingPlanId = '';

    if (checkedRadio && checkedRadio.value !== 'one_time') {
      const select = this.querySelector(`select[data-group-id="${checkedRadio.value}"]`);
      sellingPlanId = select ? select.value : '';
    }

    let hiddenInput = form.querySelector('input[name="selling_plan"]');
    if (!sellingPlanId) {
      hiddenInput?.remove();
      return;
    }

    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'selling_plan';
      form.appendChild(hiddenInput);
    }
    hiddenInput.value = sellingPlanId;
  }
}

if (!customElements.get('product-selling-plan-selector')) {
  customElements.define('product-selling-plan-selector', ProductSellingPlanSelector);
}
